"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.saveToPostQueue = saveToPostQueue;
exports.workPostQueue = workPostQueue;
exports.httpPutJsonEncoded = exports.httpDeleteJsonEncoded = exports.httpPostJsonEncoded = exports.httpGetJsonEncoded = exports.httpPut = exports.httpPost = exports.httpGetExtern = exports.httpGet = exports.DEFAULT_USER_AUTH = exports.HTTP_ERROR_OFFLINE = exports.HTTP_ERROR_PREFIX = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _AlertHelper = require("../helpers/AlertHelper");

var _CordovaHelper = require("../helpers/CordovaHelper");

var _strings = require("../../config/strings");

var _TimeoutHelper = require("../helpers/TimeoutHelper");

var _UrlHelper = _interopRequireDefault(require("../helpers/UrlHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _LogService = require("../KESI2/Services/LogService");

var _BuildConstants = require("./BuildConstants");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var querystring = require('querystring');

var METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
};
var UNAUTHORIZED = false;
var POST_QUEUE_WORKING = false;
var HTTP_ERROR_PREFIX = 'ERROR_HTTP_STATUS_';
exports.HTTP_ERROR_PREFIX = HTTP_ERROR_PREFIX;
var HTTP_ERROR_OFFLINE = "ERROR_OFFLINE";
exports.HTTP_ERROR_OFFLINE = HTTP_ERROR_OFFLINE;
var DEFAULT_USER_AUTH = '_use_default';
exports.DEFAULT_USER_AUTH = DEFAULT_USER_AUTH;

function httpCall(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _httpCall.apply(this, arguments);
}

function _httpCall() {
  _httpCall = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(method, urlEncoded, url, params, userAuth, extraHeaders, timeout, redirects) {
    var fromQueue,
        onQueueResponse,
        delayNotificationTimeout,
        noDeviceUuid,
        noXhttpRequest,
        putToQueueOnError,
        ignoreAblyConnectivity,
        additionalAcceptedHttpStatus,
        isRetryAfter401,
        applicationInstanceId,
        paramsToBe,
        urlToBe,
        parts,
        config,
        isOnline,
        request,
        delayTimer,
        closeFn,
        result,
        amongExpectedAdditionalHttpStatuses,
        isServerError,
        putToQueue,
        _request,
        okButton,
        newToken,
        _okButton,
        errorString,
        _request2,
        _args9 = arguments;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            fromQueue = _args9.length > 8 && _args9[8] !== undefined ? _args9[8] : false;
            onQueueResponse = _args9.length > 9 && _args9[9] !== undefined ? _args9[9] : null;
            delayNotificationTimeout = _args9.length > 10 && _args9[10] !== undefined ? _args9[10] : null;
            noDeviceUuid = _args9.length > 11 && _args9[11] !== undefined ? _args9[11] : false;
            noXhttpRequest = _args9.length > 12 && _args9[12] !== undefined ? _args9[12] : false;
            putToQueueOnError = _args9.length > 13 && _args9[13] !== undefined ? _args9[13] : true;
            ignoreAblyConnectivity = _args9.length > 14 && _args9[14] !== undefined ? _args9[14] : false;
            additionalAcceptedHttpStatus = _args9.length > 15 && _args9[15] !== undefined ? _args9[15] : null;
            isRetryAfter401 = _args9.length > 16 && _args9[16] !== undefined ? _args9[16] : false;
            _context9.next = 11;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 11:
            applicationInstanceId = _context9.sent;
            paramsToBe = (0, _assign["default"])(noDeviceUuid ? {} : {
              deviceuuid: applicationInstanceId
            }, params);
            urlToBe = url;

            if (method === METHODS.GET && !noDeviceUuid) {
              parts = _UrlHelper["default"].parseURL(url);

              if (parts.search) {
                if (!parts.searchObject.hasOwnProperty('deviceuuid')) {
                  if (parts.hash) {
                    urlToBe = parts.protocol + '//' + parts.host + parts.pathname + parts.search + '&deviceuuid=' + applicationInstanceId + parts.hash;
                  } else {
                    urlToBe = url + '&deviceuuid=' + applicationInstanceId;
                  }
                }
              } else {
                if (parts.hash) {
                  urlToBe = parts.protocol + '//' + parts.host + parts.pathname + '?deviceuuid=' + applicationInstanceId + parts.hash;
                } else {
                  urlToBe = url + '?deviceuuid=' + applicationInstanceId;
                }
              }

              if (_DeviceInfoHelper["default"].isInternetExplorer() && params) {
                params.reqdate = new Date().getTime();
              }

              if (params && (0, _keys["default"])(params).length > 0) {
                urlToBe += "&".concat(querystring.stringify(params));
              }
            }

            config = {
              headers: (0, _assign["default"])(noXhttpRequest ? {} : {
                'X-Requested-With': 'XMLHttpRequest'
              }, extraHeaders),
              data: urlEncoded ? querystring.stringify(paramsToBe) : paramsToBe,
              method: method,
              validateStatus: function validateStatus(status) {
                return true;
              },
              url: urlToBe
            };

            if (urlEncoded) {
              config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }

            if (userAuth) {
              if (userAuth === DEFAULT_USER_AUTH) {
                config.headers.Authorization = "Basic ".concat(window.btoa("".concat(_config["default"].defaultUser, ":").concat(_config["default"].defaultPassword)));
              } else if (userAuth) {
                config.headers.Authorization = userAuth;
              }
            }

            if (timeout) {
              config.timeout = timeout;
            }

            if (redirects) {
              config.maxRedirects = redirects;
            }

            isOnline = _DeviceInfoHelper["default"].isOnline(ignoreAblyConnectivity);

            if (isOnline) {
              _context9.next = 27;
              break;
            }

            if (!(putToQueueOnError && (method === METHODS.PUT || method === METHODS.POST))) {
              _context9.next = 26;
              break;
            }

            request = {
              method: method,
              urlEncode: urlEncoded,
              url: url,
              params: params,
              userAuth: userAuth,
              extraHeaders: extraHeaders,
              timeout: timeout,
              redirects: redirects,
              fromQueue: fromQueue,
              noDeviceUuid: noDeviceUuid,
              noXhttpRequest: noXhttpRequest
            };
            _context9.next = 26;
            return saveToPostQueue(request, onQueueResponse);

          case 26:
            return _context9.abrupt("return", _promise["default"].reject(new Error(HTTP_ERROR_OFFLINE)));

          case 27:
            delayTimer = null;
            closeFn = null;
            _context9.prev = 29;

            if (!UNAUTHORIZED) {
              _context9.next = 32;
              break;
            }

            return _context9.abrupt("return", null);

          case 32:
            if (delayNotificationTimeout) {
              delayTimer = setTimeout(function () {
                // closeFn = showAlertWithoutButton(getString('BE_PATIENT_MESSAGE'), getString('BE_PATIENT_TITLE'), false, true)
                closeFn = (0, _AlertHelper.showAlertWithOptions)({
                  message: (0, _strings.getString)('BE_PATIENT_MESSAGE'),
                  title: (0, _strings.getString)('BE_PATIENT_TITLE'),
                  showCloseButton: false,
                  buttons: [] // not even the default ok button

                });
              }, delayNotificationTimeout);
            }

            console.log('REST URL: ', config);
            _context9.next = 36;
            return _axios["default"].request(config);

          case 36:
            result = _context9.sent;
            clearTimeout(delayTimer);

            if (closeFn) {
              closeFn();
            }

            if (fromQueue && onQueueResponse) {
              onQueueResponse(result);
            }

            amongExpectedAdditionalHttpStatuses = additionalAcceptedHttpStatus && additionalAcceptedHttpStatus.includes(result.status);
            isServerError = !amongExpectedAdditionalHttpStatuses && fromQueue && result.status >= 500 && result.status <= 599;
            putToQueue = isServerError && putToQueueOnError;

            if (!(result.status >= 200 && result.status <= 299 || amongExpectedAdditionalHttpStatuses)) {
              _context9.next = 47;
              break;
            }

            return _context9.abrupt("return", _promise["default"].resolve(result));

          case 47:
            // don't notify ledger about connection errors to the same server, otherwise we'll send we produce really a lot of messages
            if (config.url.startsWith(_BuildConstants.LEDGER_HOST)) {
              console.info('connection to ledger not available, skip creating error log about that');
            } else {
              (0, _LogService.pushErrorMessage)('n/a', {
                type: "server response status ".concat(result.status),
                request: config,
                response: result,
                putBackOnQueue: putToQueue
              });
            }

          case 48:
            if (!isServerError) {
              _context9.next = 54;
              break;
            }

            console.log('POSTQUEUE: request from post queue added to queue again');
            _request = {
              method: method,
              urlEncode: urlEncoded,
              url: url,
              params: params,
              userAuth: userAuth,
              extraHeaders: extraHeaders,
              timeout: timeout,
              redirects: redirects,
              fromQueue: fromQueue,
              noDeviceUuid: noDeviceUuid,
              noXhttpRequest: noXhttpRequest
            };

            if (!putToQueueOnError) {
              _context9.next = 54;
              break;
            }

            _context9.next = 54;
            return saveToPostQueue(_request, onQueueResponse);

          case 54:
            if (!(_config["default"].resetAppOn401 && !fromQueue && result.status === 401)) {
              _context9.next = 64;
              break;
            }

            console.log('Not authorized!');
            UNAUTHORIZED = true;
            okButton = {
              label: 'OK',
              callback: function callback() {
                return (0, _CordovaHelper.resetApp)(true, 'HttpRequest httpCall resetAppOn401');
              }
            };
            (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('UNAUTHORIZED_MESSAGE'), (0, _strings.getString)('FAILURE'), false, [okButton]); // don't return a Promise here as we do not want anything to go on
            // noinspection InfiniteLoopJS

          case 59:
            if (!true) {
              _context9.next = 64;
              break;
            }

            _context9.next = 62;
            return (0, _TimeoutHelper.timeout)(30000);

          case 62:
            _context9.next = 59;
            break;

          case 64:
            if (!(result.status === 401 && !isRetryAfter401)) {
              _context9.next = 71;
              break;
            }

            _context9.next = 67;
            return _RegisterInstance["default"].forceRenewAccessToken();

          case 67:
            _context9.next = 69;
            return _RegisterInstance["default"].getAccessToken(_config["default"].authScopes);

          case 69:
            newToken = _context9.sent;
            return _context9.abrupt("return", httpCall(method, urlEncoded, url, params, "Bearer ".concat(newToken), extraHeaders, timeout, redirects, fromQueue, onQueueResponse, delayNotificationTimeout, noDeviceUuid, noXhttpRequest, putToQueueOnError, ignoreAblyConnectivity, additionalAcceptedHttpStatus, true));

          case 71:
            if (!(_config["default"].logOutOn403 && !fromQueue && result.status === 403)) {
              _context9.next = 87;
              break;
            }

            // Unauthorized Call from KESI App -> Log user out and reset all Stores (if logged in)
            console.log('KESI - Not authorized!');

            if (!(_DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.LOGGED_IN, true) || _DataStore["default"].compare(_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED, true))) {
              _context9.next = 86;
              break;
            }

            console.log('KESI - Not authorized and logged in!');
            UNAUTHORIZED = true;
            _okButton = {
              label: 'OK',
              callback: function callback() {
                return (0, _CordovaHelper.logOut)(true, null, false, 'HttpRequest httpCall logOutOn403 ok button click');
              }
            };
            (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('UNAUTHORIZED_MESSAGE'), (0, _strings.getString)('FAILURE'), false, [_okButton]);
            _context9.next = 80;
            return (0, _TimeoutHelper.timeout)(10000);

          case 80:
            (0, _CordovaHelper.logOut)(true, null, false, 'HttpRequest httpCall logOutOn403'); // don't return a Promise here as we do not want anything to go on
            // noinspection InfiniteLoopJS

          case 81:
            if (!true) {
              _context9.next = 86;
              break;
            }

            _context9.next = 84;
            return (0, _TimeoutHelper.timeout)(30000);

          case 84:
            _context9.next = 81;
            break;

          case 86:
            return _context9.abrupt("return");

          case 87:
            errorString = result.status;

            if (result.data && result.data.errors) {
              if (typeof result.data.errors === 'string') {
                errorString = result.data.errors;
              } else {
                errorString = result.data.errors[0];
              }
            }

            return _context9.abrupt("return", _promise["default"].reject(new Error("".concat(HTTP_ERROR_PREFIX).concat(errorString))));

          case 92:
            _context9.prev = 92;
            _context9.t0 = _context9["catch"](29);
            clearTimeout(delayTimer);

            if (closeFn) {
              closeFn();
            }

            console.log('error while posting!', _context9.t0);
            (0, _LogService.pushErrorMessage)('n/a', {
              type: "http request error",
              call: config,
              response: _context9.t0,
              putBackOnQueue: putToQueueOnError && (method === METHODS.PUT || method === METHODS.POST)
            }); // handle like offline request

            if (!(method === METHODS.PUT || method === METHODS.POST)) {
              _context9.next = 103;
              break;
            }

            _request2 = {
              method: method,
              urlEncode: urlEncoded,
              url: url,
              params: params,
              userAuth: userAuth,
              extraHeaders: extraHeaders,
              timeout: timeout,
              redirects: redirects,
              fromQueue: fromQueue,
              noDeviceUuid: noDeviceUuid,
              noXhttpRequest: noXhttpRequest
            };

            if (!putToQueueOnError) {
              _context9.next = 103;
              break;
            }

            _context9.next = 103;
            return saveToPostQueue(_request2, onQueueResponse);

          case 103:
            if (!_context9.t0.response) {
              _context9.next = 105;
              break;
            }

            return _context9.abrupt("return", _promise["default"].reject(_context9.t0.response.data.errors[0]));

          case 105:
            return _context9.abrupt("return", _promise["default"].reject(_context9.t0));

          case 106:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[29, 92]]);
  }));
  return _httpCall.apply(this, arguments);
}

function saveToPostQueue(_x9, _x10) {
  return _saveToPostQueue.apply(this, arguments);
}

function _saveToPostQueue() {
  _saveToPostQueue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(request, onQueueResponse) {
    var postQueue;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.QD_POST_QUEUE);

          case 2:
            _context10.t0 = _context10.sent;

            if (_context10.t0) {
              _context10.next = 5;
              break;
            }

            _context10.t0 = [];

          case 5:
            postQueue = _context10.t0;
            console.log("POSTQUEUE: call to ".concat(request.url, " stored in queue and comes from queue ? ").concat(request.fromQueue));
            _context10.prev = 7;
            postQueue.push({
              request: request,
              onQueueResponse: onQueueResponse
            });
            console.log('POSTQUEUE savetoPostQueue', postQueue);
            _context10.next = 12;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_POST_QUEUE, postQueue, false);

          case 12:
            _context10.next = 17;
            break;

          case 14:
            _context10.prev = 14;
            _context10.t1 = _context10["catch"](7);
            console.log('error while pushing post/put request to postQueue', _context10.t1);

          case 17:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[7, 14]]);
  }));
  return _saveToPostQueue.apply(this, arguments);
}

function workPostQueue(_x11) {
  return _workPostQueue.apply(this, arguments);
}

function _workPostQueue() {
  _workPostQueue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(queue) {
    var _iterator, _step, requestObj, request, postQueue;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            console.log("POSTQUEUE: work post queue", JSON.parse((0, _stringify["default"])(queue))); //
            // const promises = queue.map(async (requestObj) => {
            //   const request = requestObj.request
            //   queue.shift()
            //   await DataStore.setSingleData(DATA_STORE_PATHS.QD_POST_QUEUE, queue, false)
            //
            //   console.log(`POSTQUEUE: online, call to ${request.url} resent`)
            //   return httpCall(request.method, request.urlEncode, request.url, request.params, request.userAuth, request.extraHeaders, request.timeout, request.redirects, true, requestObj.onQueueResponse, requestObj.noDeviceUuid, requestObj.noXhttpRequest)
            // })
            // await DataStore.setSingleData(DATA_STORE_PATHS.QD_POST_QUEUE, [], false)

            _context11.prev = 1;

            if (POST_QUEUE_WORKING) {
              _context11.next = 31;
              break;
            }

            POST_QUEUE_WORKING = true;
            _iterator = _createForOfIteratorHelper(queue);
            _context11.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context11.next = 19;
              break;
            }

            requestObj = _step.value;
            request = requestObj.request;
            postQueue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_POST_QUEUE);
            postQueue.shift();
            _context11.next = 14;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_POST_QUEUE, postQueue);

          case 14:
            _context11.next = 16;
            return httpCall(request.method, request.urlEncode, request.url, request.params, request.userAuth, request.extraHeaders, request.timeout, request.redirects, true, requestObj.onQueueResponse, requestObj.noDeviceUuid, requestObj.noXhttpRequest);

          case 16:
            console.log("POSTQUEUE: online, call for ".concat(request.url, " done"));

          case 17:
            _context11.next = 7;
            break;

          case 19:
            _context11.next = 24;
            break;

          case 21:
            _context11.prev = 21;
            _context11.t0 = _context11["catch"](5);

            _iterator.e(_context11.t0);

          case 24:
            _context11.prev = 24;

            _iterator.f();

            return _context11.finish(24);

          case 27:
            // await Promise.all(promises)
            POST_QUEUE_WORKING = false;
            return _context11.abrupt("return", _promise["default"].resolve());

          case 31:
            console.log('POSTQUEUE already working');

          case 32:
            _context11.next = 39;
            break;

          case 34:
            _context11.prev = 34;
            _context11.t1 = _context11["catch"](1);
            console.log(_context11.t1);
            POST_QUEUE_WORKING = false;
            return _context11.abrupt("return", _promise["default"].reject(new Error('couldnt send postqueue', _context11.t1)));

          case 39:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 34], [5, 21, 24, 27]]);
  }));
  return _workPostQueue.apply(this, arguments);
}

var httpGet = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        noDeviceUuid,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            extraHeaders = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            timeout = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            redirects = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
            userAuth = _args.length > 5 && _args[5] !== undefined ? _args[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args.length > 6 && _args[6] !== undefined ? _args[6] : null;
            delayNotificationTimeout = _args.length > 7 && _args[7] !== undefined ? _args[7] : null;
            noDeviceUuid = _args.length > 8 && _args[8] !== undefined ? _args[8] : false;
            return _context.abrupt("return", httpCall(METHODS.GET, true, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, noDeviceUuid));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function httpGet(_x12) {
    return _ref.apply(this, arguments);
  };
}();

exports.httpGet = httpGet;

var httpGetExtern = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        ignoreAblyConnectivity,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            extraHeaders = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            timeout = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
            redirects = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
            userAuth = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : null;
            delayNotificationTimeout = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : null;
            ignoreAblyConnectivity = _args2.length > 8 && _args2[8] !== undefined ? _args2[8] : false;
            return _context2.abrupt("return", httpCall(METHODS.GET, true, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, true, true, true, ignoreAblyConnectivity));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function httpGetExtern(_x13) {
    return _ref2.apply(this, arguments);
  };
}();

exports.httpGetExtern = httpGetExtern;

var httpPost = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(url) {
    var params,
        extraHeaders,
        ignoreAblyConnectivity,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        putToQueueOnError,
        additionalAcceptedHttpStatus,
        _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            extraHeaders = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            ignoreAblyConnectivity = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
            timeout = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : null;
            redirects = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : null;
            userAuth = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : DEFAULT_USER_AUTH;
            onQueueResponse = _args3.length > 7 && _args3[7] !== undefined ? _args3[7] : null;
            delayNotificationTimeout = _args3.length > 8 && _args3[8] !== undefined ? _args3[8] : null;
            putToQueueOnError = _args3.length > 9 && _args3[9] !== undefined ? _args3[9] : true;
            additionalAcceptedHttpStatus = _args3.length > 10 && _args3[10] !== undefined ? _args3[10] : null;
            return _context3.abrupt("return", httpCall(METHODS.POST, true, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, false, false, putToQueueOnError, ignoreAblyConnectivity, additionalAcceptedHttpStatus));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function httpPost(_x14) {
    return _ref3.apply(this, arguments);
  };
}();

exports.httpPost = httpPost;

var httpPut = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        putToQueueOnError,
        _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            params = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            extraHeaders = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            timeout = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
            redirects = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : null;
            userAuth = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args4.length > 6 && _args4[6] !== undefined ? _args4[6] : null;
            delayNotificationTimeout = _args4.length > 7 && _args4[7] !== undefined ? _args4[7] : null;
            putToQueueOnError = _args4.length > 8 && _args4[8] !== undefined ? _args4[8] : true;
            return _context4.abrupt("return", httpCall(METHODS.PUT, true, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, false, false, putToQueueOnError));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function httpPut(_x15) {
    return _ref4.apply(this, arguments);
  };
}();

exports.httpPut = httpPut;

var httpGetJsonEncoded = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        _args5 = arguments;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            params = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            extraHeaders = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            timeout = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : null;
            redirects = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : null;
            userAuth = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args5.length > 6 && _args5[6] !== undefined ? _args5[6] : null;
            delayNotificationTimeout = _args5.length > 7 && _args5[7] !== undefined ? _args5[7] : null;
            return _context5.abrupt("return", httpCall(METHODS.GET, false, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function httpGetJsonEncoded(_x16) {
    return _ref5.apply(this, arguments);
  };
}();

exports.httpGetJsonEncoded = httpGetJsonEncoded;

var httpPostJsonEncoded = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        putToQueueOnError,
        _args6 = arguments;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            params = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            extraHeaders = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
            timeout = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : null;
            redirects = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : null;
            userAuth = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args6.length > 6 && _args6[6] !== undefined ? _args6[6] : null;
            delayNotificationTimeout = _args6.length > 7 && _args6[7] !== undefined ? _args6[7] : null;
            putToQueueOnError = _args6.length > 8 && _args6[8] !== undefined ? _args6[8] : true;
            return _context6.abrupt("return", httpCall(METHODS.POST, false, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, false, false, putToQueueOnError));

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function httpPostJsonEncoded(_x17) {
    return _ref6.apply(this, arguments);
  };
}();

exports.httpPostJsonEncoded = httpPostJsonEncoded;

var httpDeleteJsonEncoded = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        putToQueueOnError,
        _args7 = arguments;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            params = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            extraHeaders = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
            timeout = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
            redirects = _args7.length > 4 && _args7[4] !== undefined ? _args7[4] : null;
            userAuth = _args7.length > 5 && _args7[5] !== undefined ? _args7[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args7.length > 6 && _args7[6] !== undefined ? _args7[6] : null;
            delayNotificationTimeout = _args7.length > 7 && _args7[7] !== undefined ? _args7[7] : null;
            putToQueueOnError = _args7.length > 8 && _args7[8] !== undefined ? _args7[8] : true;
            return _context7.abrupt("return", httpCall(METHODS.DELETE, false, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, false, false, putToQueueOnError));

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function httpDeleteJsonEncoded(_x18) {
    return _ref7.apply(this, arguments);
  };
}();

exports.httpDeleteJsonEncoded = httpDeleteJsonEncoded;

var httpPutJsonEncoded = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(url) {
    var params,
        extraHeaders,
        timeout,
        redirects,
        userAuth,
        onQueueResponse,
        delayNotificationTimeout,
        putToQueueOnError,
        _args8 = arguments;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            params = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
            extraHeaders = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {};
            timeout = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : null;
            redirects = _args8.length > 4 && _args8[4] !== undefined ? _args8[4] : null;
            userAuth = _args8.length > 5 && _args8[5] !== undefined ? _args8[5] : DEFAULT_USER_AUTH;
            onQueueResponse = _args8.length > 6 && _args8[6] !== undefined ? _args8[6] : null;
            delayNotificationTimeout = _args8.length > 7 && _args8[7] !== undefined ? _args8[7] : null;
            putToQueueOnError = _args8.length > 8 && _args8[8] !== undefined ? _args8[8] : true;
            return _context8.abrupt("return", httpCall(METHODS.PUT, false, url, params, userAuth, extraHeaders, timeout, redirects, false, onQueueResponse, delayNotificationTimeout, false, false, putToQueueOnError));

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function httpPutJsonEncoded(_x19) {
    return _ref8.apply(this, arguments);
  };
}();

exports.httpPutJsonEncoded = httpPutJsonEncoded;